/**
 * Web entry point for screenshot automation. Cypress visits the app with a
 * `?screenshot=1&lang=<x>&slide=<n>` query; this turns that into the synthetic
 * deep-link URL that handleScreenshotDeepLink already knows how to parse
 * (parseIntent accepts https://…/screenshot?… URLs). Returns null when the
 * query isn't a screenshot intent, so normal web boots are unaffected.
 */
export function screenshotUrlFromSearch(search: string): string | null {
  const params = new URLSearchParams(search);
  if (params.get('screenshot') !== '1') return null;
  const lang = params.get('lang');
  const slide = params.get('slide');
  if (!lang || !slide) return null;
  return `https://harmonia.app/screenshot?lang=${lang}&slide=${slide}`;
}
